module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/july-0d78a74bdee7e88de3b78d7d08215866.png";